<template>
  <div class="appBackground">
    <NavBar />
    <!-- <TipTap /> -->
    <router-view />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
// import TipTap from '@/components/TipTap.vue'
// import firebase from 'firebase'

export default {
  name: 'App',
  components: {
    NavBar,
    // TipTap
  },
  // created() {
  //   firebase.auth().onAuthStateChanged(function(user) {
  //     if (user) {
  //       // this.$store.dispatch('bindSheets', { currentUser: user})
  //       this.$store.dispatch('bindSheets')
  //     } else {
  //       return
  //     }
  //   })
  // }
}
</script>

<style>
body {
  background-color: #F8F8F8
}
.variant {
  border-bottom: 5px solid #E8E8E8;
  padding-bottom: 5px;
}
.variant:hover {
  border-bottom: 5px solid #19A3BF;
}
.variant:hover > .variant-handle {
  border-bottom: 5px solid #19A3BF;
}
.variant:hover + .variant-handle {
  border-bottom: 5px solid #19A3BF;
}
.variant-handle{
  display: inline-block;
  width: 5px;
  border-bottom: 5px solid #E8E8E8;
}
</style>
